import Select from 'react-select';
import makeAnimated from 'react-select/animated';


const MultiSelect = ({
                         options,
                         value,
                         onChange,
                         placeholder = 'Select Properties',
                     }: {
    options: any[];
    value: any[];
    onChange: (val: any) => void;
    placeholder?: string;
}) => {
    const animatedComponents = makeAnimated();

    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            borderColor: state.isFocused ? '#3182ce' : '#CBD5E0',
            borderRadius: '0.375rem',
            fontSize: '1rem',
            boxShadow: state.isFocused ? '0 0 0 1px #2D3748' : 'none',
            color: '#000000',
        }),
        placeholder: (provided: any) => ({
            ...provided,
            color: '#1A202CFF',
            fontSize: '16px',
        }),
        menu: (provided: any) => ({
            ...provided,
            zIndex: 10,
        }),
        dropdownIndicator: (provided: any, state: any) => ({
            ...provided,
            scale: 0.75,
            color: '#2D3748',
        }),
        indicatorSeparator: () => ({}),
        multiValue: (provided: any) => ({
            ...provided,
            backgroundColor: '#EDF2F7',
            borderRadius: '0.375rem',
            padding: '2px 4px',
        }),
        multiValueLabel: (provided: any) => ({
            ...provided,
            color: '#2D3748',
            fontSize: '0.875rem',
            whiteSpace: 'normal',
            overflow: 'visible',
            textOverflow: 'unset',
            maxWidth: '100%',
        }),
        multiValueRemove: (provided: any) => ({
            ...provided,
            color: '#2D3748',
            '&:hover': {
                backgroundColor: '#E2E8F0',
                color: '#2D3748',
            },
        }),
    };

    return (
        <Select
            components={animatedComponents}
            isMulti
            options={options}
            value={value}
            onChange={onChange}
            styles={customStyles}
            closeMenuOnSelect={false}
            placeholder={placeholder}
        />
    );
};


export default MultiSelect;
